import React,{useState,useEffect} from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { AllRfqProps } from './all-rfq';
import help from './all-rfq.help';
import { useNavigate } from '@plasma/ui.application.router';
import { apiUriRfqActionHttp } from '../../services/conf/apiConf';
import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import  allRfqMasterColumns from '../../types/allRfqMasterDatatype';
function useAllRfqHook(props: AllRfqProps) {
  useResourceBundle(translations, undefined, '892ec210-a46c-4d76-9b60-0e6196e026f5');
  useHelpBundle(help);


  const { t } = useTranslation();
  const [count, setCount] = React.useState(0);
  const [dataForColumns, setdataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(allRfqMasterColumns);
  useEffect(() => {
    fetchAllDataGet_byApiName('getAllRFQ', apiUriRfqActionHttp())
      .then((data) => {
        console.log(data);
        setdataForColumns(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch companies');
      });
  }, []);


  const handleSaveAndDeleteFromTable = {};



  return {
    t,columnNames,dataForColumns,handleSaveAndDeleteFromTable

  };
}

export default useAllRfqHook;
